import { RANGE_FILTER } from '@as-react/common-types';
import { FilterActionTypes } from '../../../../enums/ActionEnums';
export const getFlattenedActiveFilters = (activeFilters) => (!!activeFilters &&
    Object.keys(activeFilters).reduce((arr, filterOn) => {
        const activeFilter = activeFilters[filterOn];
        let result = [];
        if ((activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.filterType) === FilterActionTypes.RANGE_FILTER) {
            result = [
                {
                    filterContentType: activeFilter.filterContentType,
                    filterOn: filterOn,
                    filterOnName: activeFilter.filterOnName,
                    filterType: activeFilter.filterType,
                    filterPrefix: activeFilter.filterPrefix,
                    filterSuffix: activeFilter.filterSuffix,
                    rangeMin: activeFilter.rangeMin,
                    rangeMax: activeFilter.rangeMax,
                },
            ];
        }
        else {
            if (activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.values) {
                result = activeFilter.values.map(activeFilterValue => ({
                    filterContentType: activeFilter.filterContentType,
                    filterKey: activeFilterValue.filterKey,
                    filterKeyName: activeFilterValue.filterKeyName,
                    filterOn: filterOn,
                    filterType: activeFilter.filterType,
                    filterOnName: activeFilter.filterOnName,
                }));
            }
        }
        return arr.concat(result);
    }, [])) ||
    [];
export const getActiveFilterKey = (activeFilterItem) => activeFilterItem.filterType === RANGE_FILTER
    ? activeFilterItem.filterOn
    : `${activeFilterItem.filterOn}_${activeFilterItem.filterKey}`;
